import { render } from "./IconSensor.vue?vue&type=template&id=c1284d7e"
import script from "./IconSensor.vue?vue&type=script&lang=ts"
export * from "./IconSensor.vue?vue&type=script&lang=ts"
script.render = render

export default script